// extracted by mini-css-extract-plugin
module.exports = {"SrGoingToMarketCard":"SrGoingToMarketCard--SrGoingToMarketCard--3P9hx","highlightYellowFadeIn":"SrGoingToMarketCard--highlightYellowFadeIn--1hkU7"};